import React from 'react';

export default class SkillList extends React.Component {
  constructor(props) {
    super(props);
    this.highlightTerm = this.highlightTerm.bind(this);
    this.renderSkill = this.renderSkill.bind(this);
    this.renderAliases = this.renderAliases.bind(this);
  }

  highlightTerm( line, word, className )
  {
    className = className || "highlight-underline";
    var regex = new RegExp( '(' + word + ')', 'gi' );
    return line.replace( regex, '<span class="'+ className +'">$1</span>' );
  }
  
  renderEditButton(skill, i) {
    return (
      <a key={"edit-button-" + i} href={this.props.rootUrl + "Edit/Skill/" + skill.id} className="icon edit-abstract">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><g><path d="m100 5s-5-5-10 0l-15 15 25 25 15-15c5-5 0-10 0-10z"/><path d="M 70,25 10,85 5,115 35,110 95,50 Z"/></g></svg>
      </a>
    );
  }

  renderDeleteButton(skill, i, deleteSkill) {
    return (
      <a key={"delete-button-"+i} href="javascript: void(0);" onClick={deleteSkill.bind(this, skill.id, escape(skill.name))} className="icon delete-abstract">
        <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg"><g><path d="M 30 10 L 10 30 L 40 60 L 10 90 L 30 110 L 60 80 L 90 110 L 110 90 L 80 60 L 110 30 L 90 10 L 60 40 L 30 10 z"/></g></svg>
      </a>
    );
  }

  renderSkill(skill, i) {
    return (
      <li key={i} className="skill-item">
        {this.props.canEdit? this.renderEditButton(skill, i) : null}
        {this.props.canDelete? this.renderDeleteButton(skill, i, this.props.deleteSkill) : null}
        <h3 className="skill-item-header"><span dangerouslySetInnerHTML={{__html: this.highlightTerm(skill.name, this.props.term)}}></span></h3>
        { this.renderAliases(skill.aliases) }
        <div className="skill-item-content">
          <p dangerouslySetInnerHTML={{ __html: skill.description }}></p>
        </div>
      </li>
    );
  }

  renderAliases(aliases) {
    if (!aliases || !this.props.term) return undefined;

    var matches = aliases.split(',').filter(function(alias){
      return alias.trim().toLowerCase().indexOf(this.props.term.toLowerCase()) != -1;
    }.bind(this));

    if (!matches) return undefined;

    return (
      <div className="skill-item-alias-matches">
        { matches.map(this.renderAlias.bind(this)) }
      </div>
    );
  }

  renderAlias(alias, i) {
    return (
      <span className="skill-item-alias-match" key={i} dangerouslySetInnerHTML={{__html: this.highlightTerm(alias, this.props.term)}}></span>
    );
  }

  render() {
    return (
      <ul className="skill-list">
        { this.props.skills.map(this.renderSkill) }
      </ul>
    );
  }
};
